import React from "react"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { Button, MatSymbol } from "@cirrus/ui-kit-ts"

import { AlternativeLoginButtons } from "../../containers"

const AUTHOR_BTN_ID = "author-btn-id"
const DELIVERY_BTN_ID = "delivery-btn-id"

export const RoleScreenContent = () => {
  const { i18n } = useTranslations()

  const deliveryLabel = i18n("StartPage:Delivery")
  const authorLabel = i18n("StartPage:Author")

  return <AlternativeLoginButtons>
    {/*
      Using jsx link element instead of navigation hook because of issues between routers.
      This approach might be not Storybook friendly, though
    */}

    <a href="author/app" title={authorLabel}>
      <Button fullWidth label={authorLabel} variant="outlined"
              id={AUTHOR_BTN_ID}
              startIcon={<MatSymbol color="#333333" name="edit_square"/>}/>
    </a>

    <a href="delivery/app" title={deliveryLabel}>
      <Button fullWidth label={deliveryLabel} variant="outlined"
              id={DELIVERY_BTN_ID}
              startIcon={<MatSymbol color="#333333" name="send"/>}/>
    </a>
  </AlternativeLoginButtons>
}
